export enum GamCollapseDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum GamCollapseState {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum GamSidePanelId {
  PLAYER_FILTER = 'player-filter',
  GAMBIT_FILTER = 'gambit-filter',
  LOCATIONS = 'location-view',
  LOCATION_FORM = 'location-form',
  LOCATION_DETAIL = 'location-detail',
  GAMBITS = 'gambits-view',
  GAMBIT_FORM = 'gambit-form',
  CLUBS = 'clubs-view',
  CLUB_FORM = 'club-form',
  CLUB_ORGANIZERS = 'club-organizers',
  CLUB_LOCATIONS = 'club-locations',
  CREATE_CLUB = 'create-club',
  PROFILE_GENERAL = 'profile-general',
  PROFILE_RATINGS = 'profile-ratings',
  PROFILE_NOTIFICATIONS = 'profile-notifications',
  PROFILE_EMAIL_PREFERENCES = 'profile-email-preferences',
  PROFILE_BLOCKED_USERS = 'profile-blocked-users',
  ADMIN_EDIT = 'admin-edit',
  ADMIN_LOCATION_FILTER = 'admin-location-filter',
  ADMIN_USER_FILTER = 'admin-user-filter',
}

export enum GamSidePanelOption {
  LIST = 'list',
  ACTION = 'action',
  ADD = 'add',
  EDIT = 'edit',
  DETAIL = 'detail',
}
